module.exports = __webpack_public_path__ + "static/media/forgot.86a8b425.png";